<footer class="footer tw-flex tw-justify-between tw-box-border">
  <div class="footer__info tw-flex tw-justify-center tw-items-center tw-gap-x-8">
    <div class="tw-font-strong tw-text-base">
      {{ 'footer.copyrights' | translate : { year: currentYear } }}
    </div>
  </div>
  <div class="links-section">
    <a
      *ngFor="let item of [
  {
    translationKey: 'footer.legalDocuments.imprint.title',
    link: '/legal-documents/imprint',
  },
  {
    translationKey: 'footer.legalDocuments.legalNotice.title',
    link: '/legal-documents/legal-notice',
  },
  {
    translationKey: 'footer.dependencyLicenses.title',
    link: '/legal-documents/dependency-licenses',
  },
  {
    translationKey: 'footer.dataProtectionNotice.title',
    link: '/legal-documents/data-protection-notice',
  },
  {
    translationKey: 'footer.termsAndConditions.title',
    link: '/legal-documents/terms-conditions',
  },
    ]"
      class="link footer-text"
      target="_blank"
      [routerLink]="[item.link]"
    >
      {{ item.translationKey | translate }}
    </a>
  </div>
</footer>
